/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Carrier_Form_Customer_Service_ChangedInputs */

const vi_carrier_form_customer_service_changed = /** @type {(inputs: Carrier_Form_Customer_Service_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khách đã chọn ${i?.name} khi đặt. Đổi dịch vụ thì báo lại khách.`)
};

/**

* @param {Carrier_Form_Customer_Service_ChangedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_customer_service_changed = /** @type {((inputs: Carrier_Form_Customer_Service_ChangedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Customer_Service_ChangedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_customer_service_changed(inputs)
});